import React from 'react';
import Services from './../services/services';
import Product from './Product';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

const ProductList = () => {

  const [products, setProducts] = useState([]);

  const services = new Services();

  let {privacy} = useParams();

  useEffect(()=>{

    console.log(privacy);

    if(privacy && privacy == "private"){
      console.log('PRIV')
      services.getProductsType('private').then( (value: any) => {
        setProducts(value)
      });
    }if(privacy && privacy == "public"){
      console.log('PUB')
      services.getProductsType('public').then( (value: any) => {
        setProducts(value)
      });
    }if(privacy == null){
      services.getProducts().then( (value: any) => {
        setProducts(value)
      });
    }

  }, [])


  const productList: any[] = [];

  products.forEach((data: any) => {
    console.log('short',data.short)
    if( data.attachment[0] !== undefined ){
      productList.push(<Product id={data.id} name={data.name} description={data.short} price={data.price} image={data.attachment[0].path}/>)
    }else{
      productList.push(<Product id={data.id} name={data.name} description={data.short} price={data.price} image={null}/>)
    }
  })

  return (
    <div>
      <div className="container my-5 pt-5">
      <div className="fs-1 mb-3">Produkty</div>
        <div className="row g-4">
          {productList}
        </div>
      </div>
    </div>
  );

}

export default ProductList;
